module.exports = __webpack_public_path__ + "img/vizio2-cover-3.72de9b73.jpg";